<audio id="play_ringtone"  preload="auto">
  <source src="{{origin}}/assets/ringtone/latch.mp3" type="audio/ogg">
  <source src="{{origin}}/assets/ringtone/latch.mp3" type="audio/mpeg">
</audio>
<!-- <button (click)="playRing()" type="button" id="playAudiobtn">Play Audio</button> -->

@if (data && !data.generateToken) {
  <h1 class="desk-info">{{data.desk}}</h1>
  <h1 class="next-token-info">{{data.token}}</h1>
}
@if (data && data.generateToken) {
  <h1 class="desk-info">{{data.message}}</h1>
  <div class="row float-left w-100">
    <div class="col-12 text-center mt-4">
      <button class="btn btn-primary" (click)="close()">{{'button.ok' | translate | async}}</button>
    </div>
  </div>
}